import { slugRequest } from '../slugRequest';
import {
  bid,
  v4ServiceId,
  gicpBaseUrl as baseUrl,
  gicpTestBaseUrl as testUrl,
} from '@/config/api';


// 获取V4列表
export function getV4MixedList(params = {}): any {
  const path = '/cmc/cross';

  const exclusiveChannel = 2; // 和平营地独家内容id
  const token = '5f4f3dbbb6e2c65b5ca5c74de789f022'; // 和平营地独家内容token

  const time = parseInt((new Date().getTime() / 1000).toString(), 10);

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: false,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: false,
    query: Object.assign(
      {
        serviceId: v4ServiceId,
        source: bid,
        logic: 'or',
        order: 'sIdxTime',
        typeids: '1,2',
        start: 0,
        limit: '',
        exclusiveChannel,
        exclusiveChannelSign: `${token}${v4ServiceId}${bid}${time}`,
        time,
      },
      params,
    ),
  };

  return slugRequest(config);
}

// 获取资讯详情
export function getV4NewsDetail(id: number | string): any {
  const path = '/wmp/v3.1/public/searchNews.php';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: false,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: false,
    query: {
      p0: v4ServiceId,
      source: bid,
      p1: 1,
      id,
    },
  };

  return slugRequest(config);
}

// 获取视频详情
export function getV4VideoDetail(id: number | string): any {
  const path = '/wmp/v3.1/public/search.php';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: false,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: false,
    query: {
      p0: v4ServiceId,
      source: bid,
      p1: 1,
      id,
    },
  };

  return slugRequest(config);
}

// 搜索关键字
export function getV4ListByKeyword(params: any = {}): any {
  const { keyword, start = 0, limit = 8, order } = params;

  const path = '/wmp/v3.1/';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: false,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: false,
    query: {
      p0: v4ServiceId,
      p1: 'searchIso',
      p2: keyword,
      p3: 'ALL',
      p4: 1,
      r0: 'cors',
      r1: 'obj',
      source: bid,
      order,
      page: start,
      pagesize: limit,
    },
  };

  return slugRequest(config);
}

// 浏览上报
export function updateV4TotalPlay(params: any = {}): any {
  const { p2, p3 } = params;

  const path = '/wmp/v3.1/';

  const config: ApiTypes.HttpRequestConfig = {
    testUrl: `${testUrl}${path}`,
    baseUrl,
    path,
    isAuth: false,
    source: 'backEnd',
    type: 'api',
    method: 'GET',
    underlizeQuery: false,
    query: {
      source: bid,
      p0: v4ServiceId,
      p1: 'updateTotalPlay',
      p2, // 视频id（iVideoId）/图文id（inewsid）
      p3, // 内容类型，必填。 1-视频； 2-资讯；
      p5: 1,
    },
  };

  return slugRequest(config);
}
